import { fallbackHumanizer } from './fallBackHumanizer'

export default fallbackHumanizer
